import React, { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { CandidateProfile } from '../../../Redux/action/CandidateProfileAction';
import { useDispatch, useSelector } from 'react-redux';
import { ViewVendorDashboardAction } from '../../../Redux/action/VendorDashboardAction'
import axios from 'axios';
import { border, width } from '@mui/system';
import TimezoneSelect from 'react-timezone-select';
import Select from 'react-select'
import { toast, ToastContainer } from 'react-toastify';
import { PurchaseOrderAction, PurchaseOrderDetailsAction, PurchaseOrderByPurchaseId } from '../../../Redux/action/PurchaseOrderAction';
import VideoModal from '../../Candidate/CandidateDashboard/VideoModal';
import { IoClose } from "react-icons/io5";
import { Link } from 'react-router-dom';
import { SpinLoader } from '../../Vendor/ImportCandidates';
import { useCountries } from '../../../Hooks/useCountries';
import { useStatesByCountry } from '../../../Hooks/useStatesByCountry';
import { useJobById } from '../../../Hooks/useJobDetails';
import { useCurrency } from '../../../Hooks/useCommon';
import { Button, Form, Modal } from 'react-bootstrap';
import { InterviewComplete } from '../../../Services/interviewService';
import { CurrenciesExchangeForPurchaseOrder, RejetCandidatePO, UpdatePurchaseOrder } from '../../../Services/parchaseOrderServices';
import { useInterviewById } from '../../../Hooks/useInterview';
import { FiEye } from 'react-icons/fi';
import dayjs from 'dayjs';
import { use } from 'react';
import { CurrencyExchange } from '@mui/icons-material';
import Loader from '../../Common/Loader/loader';

const ViewOrderPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [rejectModal, setRejectModal] = useState(false);
  const [rejectionReason, setRejectionReason] = useState('');
  const [rejDisable, setRejectDisable] = useState(false);
  const queryParams = new URLSearchParams(location?.search);
  const candidateId = queryParams.get('candidateId');
  const vendorId = queryParams.get('vendorId'); // ye hiring vendorID Haii
  const interviewId = queryParams.get('interviewId');
  const id = queryParams.get('purchaseId')
  const [vendorData, setVendorData] = useState({}) // ye supplier_vendorId hain..
  const [selectedTimezone, setSelectedTimezone] = useState('')
  const [isModalOpen, setIsModelOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('candidateDetails');
  const [pacchaseListData, setPachaseListData] = useState();
  const [convertedPrice, setConvertedPrice] = useState(0);
  const [convertedLoader, setConvertedLoader] = useState(false);
  const [LoadingCandidate, setLoadingCandidate] = useState(false);
  const [LoadingVendor, setLoadingVendor] = useState(false);
  const [LoadingVendor2, setLoadingVendor2] = useState(false);
  const [ParchaseLoader, setParchaseLoader] = useState(false);
  const [loaderOrder, setOrderLoader] = useState({});
  const baseUrl = process.env.REACT_APP_API_PATH
  function handleCloseModal() {
    setConvertedPrice(0)
    setSelectedTimezone('')
    document.getElementById('inputFile').value = null;
    setSelectedWork([])
    setSelectImage(null);
    setFileInfo(null);
    setError(null)
    setOrderDetail(() => (
      {
        purchaseOrderId: '',
        startDate: new Date(),
        duration: "",
        durationUnit: "month",
        workingDays: "",
        workingHours: "",
        workType: "",
        workLocation: "",
        minimumBillingHours: "",
        billingInterval: "",
        currency: "INR",
        totalAmount: "",
        status: "",
        purchaseOrderType: "",
        candidateId: "",
        vendorId: "",
        PurchaseOrderAcceptanceStatus: "PENDING",
        purchaseOrderUrl: "",
        remark: ""
      }
    ))
    setIsModelOpen(false);
  }
  // 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'
  const options = [
    { value: "MONDAY", label: "MONDAY" },
    { value: "TUESDAY", label: "TUESDAY" },
    { value: "WEDNESDAY", label: "WEDNESDAY" },
    { value: "THURSDAY", label: "THURSDAY" },
    { value: "FRIDAY", label: "FRIDAY" },
    { value: "SATURDAY", label: "SATURDAY" },
    { value: "SUNDAY", label: "SUNDAY" }
  ]
  const { data: currency_data } = useCurrency()


  const fetchData = async () => {
    setLoadingCandidate(true);
    try {
      setLoadingVendor2(true);
      dispatch(ViewVendorDashboardAction({ vendorId })).then((res) => {
        setLoadingVendor2(false);
      }).catch((err) => {
        setLoadingVendor2(false);
      });
      const res = await dispatch(CandidateProfile(candidateId)).then((res) => {
        setLoadingCandidate(false);
        if (res?.data?.vendorId) {
          const vendorId = res?.data?.vendorId;
          axios.get(`${baseUrl}/ebench/get_vendor_by_vendorId?vendorId=${vendorId}`).then((res) => {
            if (res?.data?.data) {
              setLoadingVendor(false);
              setVendorData(res?.data?.data)
            }
          })
        }
      }).catch((err) => {
        setLoadingCandidate(false);
      });;
      setLoadingVendor(true);


    } catch (error) {
      setLoadingCandidate(false);
      setLoadingVendor(false);
    }
  };
  useEffect(() => {
    fetchData();
    setParchaseLoader(true);
    dispatch(PurchaseOrderDetailsAction(state?.interviewId)).then((res) => {
      setParchaseLoader(false);
    }).catch((err) => {
      setParchaseLoader(false);
    })
  }, [activeTab]);

  useEffect(() => {
    location.pathname.includes('purchase_list') &&
      dispatch(PurchaseOrderByPurchaseId(id)).then((res) => {
        setPachaseListData(res?.data)
      })
  }, [!location.pathname.includes('purchase_list')])

  const getTomorrowDate = () => {
    const today = new Date();
    today.setDate(today.getDate() + 1); // Add 1 day for tomorrow
    return today.toISOString().split('T')[0]; // Format YYYY-MM-DD
  };
  const navigate = useNavigate();
  const [orderDetail, setOrderDetail] = useState({
    purchaseOrderId: '',
    startDate: new Date(new Date().setDate(new Date().getDate() + 1)),
    duration: "",
    durationUnit: "month",
    PurchaseOrderAcceptanceStatus: "PENDING",
    timeZone: selectedTimezone?.label,
    workingDays: "",
    workingHours: "",
    workType: "",
    workLocation: "",
    minimumBillingHours: "",
    billingInterval: "",
    currency: "INR",
    totalAmount: "",
    status: "",
    purchaseOrderType: "",
    candidateId: "",
    vendorId: "",
    purchaseOrderUrl: "",
    remark: "",
    country: "",
    state: "",
  })

  const { data: countriesData } = useCountries();
  const { data: stateList, } = useStatesByCountry(orderDetail?.country || "India");
  const { data: jobsData } = useJobById(state?.jobId);

  const formatDateToInputValue = (date) => {
    const year = date?.getFullYear();
    const month = String(date?.getMonth() + 1)?.padStart(2, '0');
    const day = String(date?.getDate())?.padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const formatDateToInputValue1 = (date) => {
    const year = date?.getFullYear();
    const month = String(date?.getMonth() + 1)?.padStart(2, '0');
    const day = String(date?.getDate())?.padStart(2, '0');
    return `${day}-${month}-${year}`;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") {
      // Convert date string to Date object
      setOrderDetail((prevDetail) => ({
        ...prevDetail,
        startDate: new Date(value),
      }));
    }
    else {
      setOrderDetail((prevDetail) => ({
        ...prevDetail,
        [name]: value,
      }));
    }
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formdata = new FormData();
    formdata.append('purchaseOrderRequest', JSON.stringify({
      "purchaseOrderId": orderDetail.purchaseOrderId,
      "startDate": formatDateToInputValue1(orderDetail?.startDate),
      "duration": orderDetail?.duration + ' ' + orderDetail?.durationUnit,
      "timeZone": jobsData?.timeZone,
      "workingDays": null,
      "workingHours": orderDetail?.workingHours,
      "workType": orderDetail?.workType,
      "workLocation": orderDetail?.workLocation,
      "minimumBillingHours": orderDetail?.minimumBillingHours,
      "billingInterval": orderDetail?.billingInterval,
      "currency": orderDetail?.currency,
      "totalAmount": orderDetail?.totalAmount,
      "purchaseOrderType": orderDetail?.purchaseOrderType,
      "candidateId": candidateId,
      "interviewId": interviewId,
      "interviewerVendorId": state.interviewerVendorId,
      "candidateVendorId": state.candidateVendorId || null,
      "jobId": state.jobId,
      "country": orderDetail.country,
      "state": orderDetail.state,
      "USDAmount": convertedPrice,
    }));
    formdata.append('purchaseOrderFile', selectImage)
    setButtonStatus(true);
    if (orderDetail?.purchaseOrderId && orderDetail?.purchaseOrderUrl) {
      try {
        const response = await UpdatePurchaseOrder(formdata);
        fetchData();
        setActiveTab('purchseDetails');
        dispatch(PurchaseOrderDetailsAction(interviewId));
        setTimeout(() => {
          handleCloseModal();
          setButtonStatus(false);
        }, 500)
      } catch (err) {
        setButtonStatus(false);
      }
    } else {
      dispatch(PurchaseOrderAction(formdata)).then((res) => {
        if (res?.data) {
          fetchData();
          setActiveTab('purchseDetails');
          dispatch(PurchaseOrderDetailsAction(interviewId));
          setTimeout(() => {
            handleCloseModal();
            setButtonStatus(false);
          }, 500)
        }
      }).catch((err) => {
        setButtonStatus(false);
      })
    }
  }
  const Working = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY']
  const [selectedWork, setSelectedWork] = useState([])
  const [selectImage, setSelectImage] = useState('');

  const handleSkillsChange = (selectOption) => {
    setSelectedWork(selectOption)
    const selectValue = selectOption?.map((item) => item.value);
    setOrderDetail((data) => ({
      ...data,
      workingDays: selectValue
    }))
  }

  const removeImage = () => {
    setSelectImage(null);
    setFileInfo(null);
    document.getElementById('inputFile').value = null;
  }

  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
  }

  const PurchaseOrderDetail = useSelector((state) => state?.PurchaseOrderDetails?.result);
  const CandidateDetails = useSelector((state) => state?.Profile?.result);
  const vendorResourceDetails = useSelector((state) => state?.VendorSideDashboard?.result)
  const purchaseArray = location.pathname.includes('purchase_list') ? [pacchaseListData] : PurchaseOrderDetail
  const [buttonStatus, setButtonStatus] = useState(false)
  const { data: interviewData, isLoading } = useInterviewById(interviewId);
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  }

  const [fileInfo, setFileInfo] = useState(null);
  const [error, setError] = useState('');

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    const fileType = file.type;
    const fileSizeMB = file.size / 1024 / 1024;

    const isPdf = fileType === 'application/pdf';
    const isDoc = fileType === 'application/msword';
    const isDocx = fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

    if (isPdf || isDoc || isDocx) {
      if (fileSizeMB <= 5) { // Optional size check (5MB or your limit)
        setFileInfo({
          name: file.name,
          type: isPdf ? 'pdf' : 'doc',
        });
        setSelectImage(file);
        setError('');
      } else {
        toast.error("File size should be less than 5MB");
        setSelectImage(null);
        setFileInfo(null);
      }
    } else {
      toast.error("Only PDF or Word documents are allowed.");
      setFileInfo(null);
      setSelectImage(null);
    }
  };

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (orderDetail?.workType === "REMOTE") {
      setOrderDetail({ ...orderDetail, state: "", country: "" })
    }
  }, [orderDetail?.workType]);

  const handleReject = () => {
    if (!rejectionReason) {
      toast.error("Please add reason")
      return;
    }
    setRejectDisable(true)
    const candidateIdNew = parseInt(candidateId)
    const formData = {
      candidateId: candidateIdNew,
      rejectionReason: rejectionReason
    }
    RejetCandidatePO(formData).then((res) => {
      setTimeout(() => {
        navigate(-1)
        setRejectModal(false)
        setRejectDisable(false)
        setRejectionReason('')
      }, 2000);
    }).catch(() => {
      setRejectDisable(false)
    });
  }

  useEffect(() => {
    if (!orderDetail?.currency || !orderDetail?.totalAmount) return;
    setConvertedLoader(true)
    const handler = setTimeout(() => {
      CurrenciesExchangeForPurchaseOrder(orderDetail.currency, "USD", orderDetail.totalAmount)
        ?.then((res) => {
          setConvertedPrice(res?.data?.conversion_result || 0);
          setConvertedLoader(false);
        }).catch(() => setConvertedLoader(false));
    }, 900); // debounce delay (ms)

    return () => {
      clearTimeout(handler); // Cleanup on value change
    };
  }, [orderDetail?.totalAmount, orderDetail?.currency]);

  const purchaseOrderTypes = purchaseArray?.length > 0 ? purchaseArray?.map(item => item.purchaseOrderType || "None") : [];



  return (

    <div style={{ backgroundColor: 'white' }}>
      <ToastContainer />
      <Modal
        show={rejectModal}
        onHide={() => { setRejectModal(false); setRejectionReason(' ') }}
        backdrop="static"
        keyboard={false}
        style={{ top: "25%" }}
      >
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">Reject</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-start">
          <Form>
            <Form.Group >
              <Form.Label className="fs-5">Reason for rejection <span style={{ color: 'red' }}>*</span></Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={rejectionReason}
                onChange={(e) => setRejectionReason(e.target.value)}
                required
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            variant="success"
            disabled={rejDisable}
            className="btn-lg"
            onClick={handleReject}
          >
            {rejDisable ? "Loading..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer />
      <div className='can_prof_container'>
        {/* Start line of code */}
        <div style={{ position: 'relative' }}>
          <div
          style={{
              width: '97%', // Inherit the parent's width (97% of its container)
              position: 'absolute',
              top: '-2rem',
            backgroundColor: 'white',
              zIndex: 9,
              marginLeft: '0.5rem',
          }}
          className='common_wrapper mb-4 d-flex justify-content-between align-items-center'
        >
          <ul className="nav nav-pills justify-content-start" style={{ display: 'flex' }}>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "candidateDetails" ? "active bg_primary color_white" : ""}`}
                  style={{ fontSize: width > 500 ? '14px' : '8px' }}
                onClick={() => handleTabChange("candidateDetails")}
              >
                Candidate Details
              </button>
            </li>
            {purchaseArray?.length > 0 && (
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "purchseDetails" ? "active bg_primary color_white" : ""}`}
                    style={{ fontSize: width > 500 ? '14px' : '8px' }}
                  onClick={() => setActiveTab("purchseDetails")}
                >
                  Purchase Order Details
                </button>
              </li>
            )}
          </ul>
          <div className='d-flex gap-2'>
            {PurchaseOrderDetail?.length !== 2 && !location.pathname.includes('purchase_list') && interviewData?.purchaseOrderCreated !== 'Rejected' && (
              <button
                className='btn-primary-custom'
                style={{ fontSize: width > 500 ? '14px' : '8px', paddingLeft: 10, paddingRight: 10 }}
                onClick={() => setIsModelOpen(true)}
              >
                Create Purchase Order
              </button>
            )}
          </div>
        </div>
        </div>
        {(ParchaseLoader || isLoading || LoadingCandidate || LoadingVendor || LoadingVendor2) ? <div style={{ height: "70vh", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Loader />
        </div>
          : <div style={{ paddingTop: width > 414 ? 10 : '80px', backgroundColor: '#f6f9ff', width: '99%', margin: '0 auto', height: '75vh', overflow: 'scroll', marginTop: location.pathname.includes('purchase_list') && width > 500 ? "38px" : '30px' }}>
            {activeTab == 'candidateDetails' &&
              <div className="vj_wrapper" style={{ padding: "1.5rem" }}>
                <div style={{ boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.1)" }}>
                  <div style={{ paddingRight: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: 'white' }}>
                    <div className="common_table_header" > Candidate Details </div>
                  </div>
                  <div className="line_divide"></div>
                  <div style={{ padding: 20, backgroundColor: 'white' }}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: width > 786 ? 'row' : 'column',
                        gap: '30px',
                        width: '100%',
                      }}
                    >
                      {/* Profile Image */}
                      <div style={{ height: '12rem', width: '12rem', borderRadius: 10, padding: 3 }}>
                        <img
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            borderRadius: 10,
                          }}
                          src={
                            CandidateDetails?.profileImageUrl ||
                            'https://w7.pngwing.com/pngs/910/606/png-transparent-head-the-dummy-avatar-man-tie-jacket-user-thumbnail.png'
                          }
                          alt=""
                        />
                      </div>

                      {/* Candidate Info */}
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns: width > 1100 ? '1fr 1fr' : '1fr', // 👈 2 cols on big, 1 on small
                            gap: '12px 30px',
                            width: '100%',
                          }}
                        >
                          {[
                            { label: 'Employee Id', value: CandidateDetails?.candidateEmpId },
                            { label: 'Full Name', value: `${CandidateDetails?.firstName} ${CandidateDetails?.lastName}` },
                            { label: 'Phone', value: `+${CandidateDetails?.dialCode} ${CandidateDetails?.mobile}` },
                            { label: 'Experience', value: CandidateDetails?.keyExperience },
                            { label: 'Designation', value: CandidateDetails?.currentDesignation },
                            { label: 'Email', value: CandidateDetails?.email },
                            { label: 'PAN NO.', value: CandidateDetails?.panCardNumber },
                            { label: 'AADHAAR NO.', value: CandidateDetails?.aadharCardNumber },
                            { label: 'Department', value: CandidateDetails?.department?.replace(/_/g, ' ') || 'N/A' },
                            { label: 'Skills', value: CandidateDetails?.skillList?.join(', ') || 'N/A' },
                            CandidateDetails?.isRejected && {
                              label: 'Rejection Reason',
                              value: CandidateDetails?.rejectionReason || 'N/A',
                            },
                          ]
                            .filter(Boolean)
                            .map((item, index) => (
                              <div
                                key={index}
                                style={{
                                  display: 'flex',
                                  alignItems: 'flex-start',
                                  gap: '10px',
                                  paddingBottom: '6px',
                                }}
                              >
                                {/* Label */}
                                <div
                                  style={{
                                    fontWeight: 500,
                                    color: 'rgba(1, 41, 112, 0.6)',
                                    fontSize: width > 500 ? '15px' : '12px',
                                    minWidth: width > 500 ? "160px" : "90px",
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {item.label}:
                                </div>

                                {/* Value */}
                                <div
                                  style={{
                                    fontWeight: 400,
                                    fontSize: width > 500 ? '15px' : '12px',
                                    color: '#000',
                                    wordBreak: 'break-word',
                                    flex: 1,
                                  }}
                                >
                                  {item.value || 'N/A'}
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            }
            {/* ========================== details ========================== */}
            {activeTab === 'candidateDetails' &&
              <div style={{ padding: "1.5rem" }} className="vj_wrapper">
                <div style={{ boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.1)" }}>
                  <p className="common_table_header" style={{ margin: "0px" }}>
                    Resource Provider (Supplier) Details
                  </p>
                  <div className="line_divide"></div>

                  {Object.keys(vendorData)?.length > 0 ? (
                    <div style={{ padding: 20, backgroundColor: "white" }}>
                      <div style={{ display: "flex", gap: "30px", flexDirection: width > 786 ? 'row' : 'column', width: "100%" }}>
                        {/* Profile Image */}
                        <div style={{ height: "12rem", width: "12rem", borderRadius: 10, padding: 3 }}>
                          <img
                            style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: 10 }}
                            src={
                              vendorData?.vendorProfileImageUrl ||
                              "https://w7.pngwing.com/pngs/910/606/png-transparent-head-the-dummy-avatar-man-tie-jacket-user-thumbnail.png"
                            }
                            alt=""
                          />
                        </div>

                        {/* Vendor Details */}
                        <div style={{ flex: 1 }}>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: width > 1100 ? "1fr 1fr" : "1fr", // 👈 2 cols on desktop, 1 on mobile
                              gap: "12px 30px",
                              width: "100%",
                            }}
                          >
                            {[
                              { label: "Vendor Id", value: vendorData?.vendorEmpId || "N/A" },
                              { label: "Vendor Name", value: `${vendorData?.firstName ?? "N/A"} ${vendorData?.lastName ?? ""}` },
                              { label: "Phone", value: `+${vendorData?.dialCode} ${vendorData?.mobile ?? "N/A"}` },
                              { label: "Email", value: vendorData?.email ?? "N/A" },
                              { label: "Company Name", value: vendorData?.company ?? "N/A" },
                              {
                                label: "Company Website",
                                value: vendorData?.companyWebsite ? (
                                  <a href={vendorData?.companyWebsite} target="_blank" rel="noopener noreferrer">
                                    {vendorData?.companyWebsite}
                                  </a>
                                ) : (
                                  "N/A"
                                ),
                              },
                              {
                                label: "Location",
                                value:
                                  vendorData?.locations?.length > 0
                                    ? vendorData.locations
                                      .map(
                                        (loc) =>
                                          `${loc.locationType}: ${loc.city || ""} ${loc.state || ""} ${loc.country || ""}`
                                            .trim()
                                            .split(" ")
                                            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                            .join(" ")
                                      )
                                      .join(" | ")
                                    : "N/A",
                              },
                              {
                                label: "Company Logo",
                                value: vendorData?.companyLogoUrl ? (
                                  <a href={vendorData?.companyLogoUrl} target="_blank" rel="noopener noreferrer">
                                    Link
                                  </a>
                                ) : (
                                  "N/A"
                                ),
                              },
                            ].map((item, index) => (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  gap: "10px",
                                  paddingBottom: "6px",
                                }}
                              >
                                {/* Label */}
                                <div
                                  style={{
                                    fontWeight: 500,
                                    color: "rgba(1, 41, 112, 0.6)",
                                    fontSize: width > 500 ? "15px" : "12px",
                                    minWidth: width > 500 ? "160px" : "100px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {item.label}:
                                </div>

                                {/* Value */}
                                <div
                                  style={{
                                    fontWeight: 400,
                                    fontSize: width > 500 ? "15px" : "12px",
                                    color: "#000",
                                    wordBreak: "break-word",
                                    flex: 1,
                                  }}
                                >
                                  {item.value}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div style={{ padding: 20, backgroundColor: "white" }}>
                      This Candidate has no Resource Provider, it's an Individual Candidate.
                    </div>
                  )}
                </div>
              </div>

            }

            {/* ================== Resource Hiring Details ================== */}
            {activeTab === 'candidateDetails' &&
              <div style={{ padding: "1.5rem" }} className="vj_wrapper">
                <div style={{ boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.1)" }}>
                  <p className="common_table_header" style={{ margin: "0px" }}>
                    Resource Hiring (Buyer) Details
                  </p>
                  <div className="line_divide"></div>

                  <div style={{ padding: 20, backgroundColor: "white" }}>
                    <div style={{ display: "flex", gap: "30px", flexDirection: width > 786 ? 'row' : 'column', width: "100%" }}>
                      {/* Profile Image */}
                      <div style={{ height: "12rem", width: "12rem", borderRadius: 10, padding: 3 }}>
                        <img
                          style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: 10 }}
                          src={
                            vendorResourceDetails?.vendorProfileImageUrl ||
                            "https://w7.pngwing.com/pngs/910/606/png-transparent-head-the-dummy-avatar-man-tie-jacket-user-thumbnail.png"
                          }
                          alt=""
                        />
                      </div>

                      {/* Vendor Details */}
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: width > 1100 ? "1fr 1fr" : "1fr", // 👈 2 per row on large, 1 per row on small
                            gap: "12px 30px",
                            width: "100%",
                          }}
                        >
                          {[
                            { label: "Vendor Id", value: vendorResourceDetails?.vendorEmpId || "N/A" },
                            { label: "Vendor Name", value: `${vendorResourceDetails?.firstName ?? "N/A"} ${vendorResourceDetails?.lastName ?? ""}` },
                            { label: "Phone", value: `+${vendorResourceDetails?.dialCode} ${vendorResourceDetails?.mobile ?? "N/A"}` },
                            { label: "Email", value: vendorResourceDetails?.email ?? "N/A" },
                            { label: "Company Name", value: vendorResourceDetails?.company ?? "N/A" },
                            {
                              label: "Company Website",
                              value: vendorResourceDetails?.companyWebsite ? (
                                <a href={vendorResourceDetails?.companyWebsite} target="_blank" rel="noopener noreferrer">
                                  {vendorResourceDetails?.companyWebsite}
                                </a>
                              ) : (
                                "N/A"
                              ),
                            },
                            {
                              label: "Location",
                              value:
                                vendorResourceDetails?.locations?.length > 0
                                  ? vendorResourceDetails.locations
                                    .map(
                                      (loc) =>
                                        `${loc.locationType}: ${loc.city || ""} ${loc.state || ""} ${loc.country || ""}`
                                          .trim()
                                          .split(" ")
                                          .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                          .join(" ")
                                    )
                                    .join(" | ")
                                  : "N/A",
                            },
                            {
                              label: "Company Logo",
                              value: vendorResourceDetails?.companyLogoUrl ? (
                                <a href={vendorResourceDetails?.companyLogoUrl} target="_blank" rel="noopener noreferrer">
                                  Link
                                </a>
                              ) : (
                                "N/A"
                              ),
                            },
                          ].map((item, index) => (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "10px",
                                paddingBottom: "6px",
                              }}
                            >
                              {/* Label */}
                              <div
                                style={{
                                  fontWeight: 500,
                                  color: "rgba(1, 41, 112, 0.6)",
                                  fontSize: width > 500 ? "15px" : "12px",
                                  minWidth: width > 500 ? "160px" : "100px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {item.label}:
                              </div>

                              {/* Value */}
                              <div
                                style={{
                                  fontWeight: 400,
                                  fontSize: width > 500 ? "15px" : "12px",
                                  color: "#000",
                                  wordBreak: "break-word",
                                  flex: 1,
                                }}
                              >
                                {item.value}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            }
            {purchaseArray?.length > 0 && activeTab === 'purchseDetails' &&
              purchaseArray?.map((detail) => (
                <div>
                  <div style={{ padding: "1.5rem" }} className="vj_wrapper">
                    <div style={{ boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.1)" }}>
                      <div className='d-flex flex-wrap common_table_header gap-2 justify-content-between'>
                        <p className="" style={{ margin: "0px" }}> {detail?.purchaseOrderType == 'CLIENT_ORDER' ? 'Client Order Details' : detail?.purchaseOrderType == "SUPPLIER_ORDER" ? 'Supplier Order Details' : 'Candidate Order Details'}  </p>
                        {detail?.purchaseOrderAcceptanceStatus === 'REQUEST_TO_CHANGE' && (
                          <button
                            className='btn-primary-custom'
                            style={{ fontSize: width > 500 ? '14px' : '8px', paddingLeft: 10, paddingRight: 10 }}
                            onClick={() => {
                              setIsModelOpen(true); setOrderDetail(() => (
                                {
                                  purchaseOrderId: detail?.purchaseOrderId,
                                  purchaseOrderType: detail?.purchaseOrderType,
                                  durationUnit: "month",
                                  PurchaseOrderAcceptanceStatus: "PENDING",
                                  currency: 'INR',
                                })
                              )
                            }}
                          >
                            Revise Purchase Order
                          </button>
                        )}
                        {detail?.purchaseOrderAcceptanceStatus === 'PENDING' && (
                          <button
                            className='btn-primary-custom'
                            style={{ fontSize: width > 500 ? '14px' : '8px', paddingLeft: 10, paddingRight: 10 }}
                            onClick={() => {
                              setIsModelOpen(true); setOrderDetail(() => (
                                {
                                  purchaseOrderId: detail?.purchaseOrderId,
                                  startDate: dayjs(detail?.startDate, "DD-MM-YYYY").toDate(),
                                  duration: detail?.duration?.split(" ")[0] ?? 'N/A',
                                  durationUnit: detail?.duration?.split(" ")[1] ?? 'N/A',
                                  workingDays: detail?.workingDays,
                                  workingHours: detail?.workingHours,
                                  workType: detail?.workType,
                                  workLocation: detail?.workLocation,
                                  minimumBillingHours: detail?.minimumBillingHours,
                                  billingInterval: detail?.billingInterval,
                                  currency: detail?.currency,
                                  totalAmount: detail?.totalAmount,
                                  status: detail?.status,
                                  state: detail?.state,
                                  country: detail?.country,
                                  purchaseOrderType: detail?.purchaseOrderType,
                                  candidateId: detail?.candidateId,
                                  vendorId: detail?.vendorId,
                                  PurchaseOrderAcceptanceStatus: detail?.PurchaseOrderAcceptanceStatus,
                                  purchaseOrderUrl: detail?.purchaseOrderUrl,
                                  remark: detail?.remark
                                }
                              ))
                            }}
                          >
                            Update Purchase Order
                          </button>
                        )}
                      </div>
                      <div className="line_divide"></div>
                      <div style={{ padding: 20, backgroundColor: 'white' }}>
                        <table style={{ width: '100%', wordBreak: 'break-word' }}>
                          <tbody style={{
                            display: 'grid',
                            gridTemplateColumns: width > 500 ? 'repeat(auto-fit, minmax(360px, 1fr))' : 'repeat(auto-fit, minmax(250px, 1fr))',
                            gap: 10
                          }}>
                            {[
                              { label: "Order ID", value: detail?.purchaseOrderId },
                              { label: "Start Date", value: detail?.startDate },
                              { label: "Duration", value: detail?.duration ?? "N/A" },
                              { label: "Working Hour", value: detail?.workingHours ?? "N/A" },
                              { label: "Work Type", value: detail?.workType ?? "N/A" },
                              ...(detail?.workType !== "REMOTE"
                                ? [
                                  { label: "Country", value: detail?.country || "N/A" },
                                  { label: "State", value: detail?.state || "N/A" },
                                  detail?.workLocation && { label: "Work Location", value: detail?.workLocation }
                                ].filter(Boolean)
                                : []),
                              { label: "Billing Hours", value: detail?.minimumBillingHours ?? "N/A" },
                              { label: "Billing Interval", value: detail?.billingInterval ?? "N/A" },
                              { label: "Purchase Amount", value: `${detail?.totalAmount ?? 'N/A'} ${detail?.currency || ""}` },
                              { label: "Purchase Order Type", value: detail?.purchaseOrderType?.split("_").join(" ") ?? "N/A" },
                              // 🎯 Conditional Vendor Information Based on Order Type
                              ...(detail?.purchaseOrderType === "SUPPLIER_ORDER"
                                ? [
                                  {
                                    label: "Candidate Vendor Name",
                                    value: detail?.candidateVendorName || "N/A"
                                  },
                                  {
                                    label: "Candidate Vendor ID",
                                    value: detail?.candidateVendorId || "N/A"
                                  }
                                ]
                                : []),
                              ...(detail?.purchaseOrderType === "CLIENT_ORDER"
                                ? [
                                  {
                                    label: "Interviewer Vendor Name",
                                    value: detail?.interviewerVendorName || "N/A"
                                  },
                                  {
                                    label: "Interviewer Vendor ID",
                                    value: detail?.interviewerVendorId || "N/A"
                                  }
                                ]
                                : []),
                              {
                                label: "Acceptance Status",
                                value: (
                                  <span
                                    style={{
                                      padding: 6,
                                      borderRadius: 5,
                                      fontSize: width > 760 ? "14px" : "12px",
                                      color:
                                        detail?.purchaseOrderAcceptanceStatus === "REJECTED"
                                          ? "#ff0000"
                                          : detail?.purchaseOrderAcceptanceStatus === "PENDING" || detail?.purchaseOrderAcceptanceStatus === "REQUEST_TO_CHANGE"
                                            ? "#c29100"
                                            : "#007d3b",
                                      backgroundColor:
                                        detail?.purchaseOrderAcceptanceStatus === "REJECTED"
                                          ? "#ffd6d6"
                                          : detail?.purchaseOrderAcceptanceStatus === "PENDING" || detail?.purchaseOrderAcceptanceStatus === "REQUEST_TO_CHANGE"
                                            ? "#fff5c0"
                                            : "#cbffe1"
                                    }}
                                  >
                                    {detail?.purchaseOrderAcceptanceStatus ?? "N/A"}
                                  </span>
                                )
                              },
                              ...(detail?.purchaseOrderAcceptanceStatus === "REJECTED" || detail?.purchaseOrderAcceptanceStatus === "REQUEST_TO_CHANGE"
                                ? [{ label: "Reason", value: detail?.remark || "N/A" }]
                                : []),
                              { label: "Created Date", value: detail?.createdAt ?? "N/A" },
                              ...(detail?.purchaseOrderUrl
                                ? [
                                  {
                                    label: "Purchase Order Document",
                                    value: (
                                      <a href={detail.purchaseOrderUrl} target="_blank" rel="noopener noreferrer" >
                                        <button className='btn-primary-custom'
                                          style={{ fontSize: width > 500 ? '14px' : '8px', paddingLeft: 10, paddingRight: 10 }}>view</button>
                                      </a>
                                    )
                                  }
                                ]
                                : []),
                              { label: "Timezone", value: detail?.timeZone ?? "N/A" }
                            ].map((item, index) => (
                              <tr key={index} style={{ display: 'flex', gap: 10 }}>
                                <th style={{ width: '35%', color: 'rgba(1, 41, 112, 0.6)', wordBreak: 'break-word', fontWeight: 300, fontSize: width > 500 ? '15px' : '12px' }}>
                                  {item.label}
                                </th>
                                <td style={{ wordBreak: 'break-word', fontWeight: 300, fontSize: width > 500 ? '15px' : '12px' }}>
                                  {item.value}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <VideoModal
                    showModal={showModal}
                    handleClose={handleClose}
                    title={`Purchase Order Documents`}
                    newWindow={true}
                    resumeUrl={detail?.purchaseOrderUrl}
                    body={
                      <div className="profile-video d-flex justify-content-center" style={{ margin: '0 auto', height: '80vh' }}>
                        {detail?.purchaseOrderUrl ? (
                          detail?.purchaseOrderUrl.endsWith('.pdf') ? (
                            <iframe
                              src={detail?.purchaseOrderUrl}
                              title="Purchase Order PDF"
                              width="800rem"
                              height="100%"
                            // style={{ display: isLoading ? 'none' : 'block' }}
                            />
                          ) : (
                            <img
                              style={{ objectFit: 'contain', width: '100%', height: '100%' }}
                              src={detail?.purchaseOrderUrl}
                              // onLoad={handleImageLoad}
                              alt="Purchase Order"
                            />
                          )
                        ) : (
                          <p>No file available.</p> // Optional message for no file
                        )}
                      </div>
                    }
                  />
                </div>
              ))
            }
          </div>
        }


      </div>
      {
        isModalOpen &&
        <div className="new_modal-overlay" isOpen={isModalOpen} onClose={handleCloseModal}>
            <div className="new_modal" style={{ backgroundColor: 'white', padding: 4 }}>
              <div style={{ position: 'fixed', zIndex: 99, backgroundColor: 'white', display: 'flex', width: '78%', justifyContent: 'space-between' }}>
                <p style={{ padding: 10, margin: 0 }} className="common_table_header">Purchase Order Form</p>
              {/* <span style={{ border:'2px solid black',padding:'0px' }} > */}
              <IoClose style={{ cursor: 'pointer' }} onClick={handleCloseModal} color='red' size={27} />
              {/* </span> */}
                <hr style={{ position: 'fixed', width: '80%', marginTop: '38px' }} />
            </div>
            <form onSubmit={handleSubmit} style={{ marginTop: '4.5rem', padding: '20px', paddingTop: 0 }} className="ca">
              <div className="row gx-3 mb-3">
                <div className="col-md-4">
                    <label className="small mb-1" htmlFor="inputCourseProvider">
                      Purchase Order Type<span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="purchaseOrderType"
                      value={orderDetail?.purchaseOrderType || ""}
                      onChange={handleInputChange}
                      required
                      disabled={!!orderDetail?.purchaseOrderId} // disable full select if ID exists
                    >
                      <option value="">SELECT</option>

                      {Object.keys(vendorData || {})?.length > 0 && (
                        <option
                          value="SUPPLIER_ORDER"
                          disabled={purchaseOrderTypes.includes("SUPPLIER_ORDER")}
                        >
                          SUPPLIER ORDER {(purchaseOrderTypes?.includes("SUPPLIER_ORDER") && !orderDetail?.purchaseOrderId) && "(already created)"}
                        </option>
                      )}

                      <option
                        value="CLIENT_ORDER"
                        disabled={purchaseOrderTypes.includes("CLIENT_ORDER")}
                      >
                        CLIENT ORDER {purchaseOrderTypes?.includes("CLIENT_ORDER") && !orderDetail?.purchaseOrderId && "(already created)"}
                      </option>

                      {Object.keys(vendorData || {})?.length === 0 && (
                        <option
                          value="CANDIDATE_ORDER"
                          disabled={purchaseOrderTypes.includes("CANDIDATE_ORDER")}
                        >
                          CANDIDATE ORDER {(purchaseOrderTypes?.includes("CANDIDATE_ORDER") && !orderDetail?.purchaseOrderId) && "(already created)"}
                        </option>
                      )}
                    </select>

                  </div>
                  <div className="col-md-4">
                  <label className="small mb-1" htmlFor="inputCourseName">
                    Start Date<span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                  </label>
                  <input
                    type="date"
                    id="inputCourseName"
                    className="form-control"
                    placeholder='Order Detail'
                    name="startDate"
                    value={formatDateToInputValue(orderDetail.startDate)}
                    onChange={handleInputChange}
                    required
                    min={getTomorrowDate()}
                  />
                </div>
                <div className="col-md-4">
                  <label className="small mb-1" htmlFor="inputDuration">
                    Duration<span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                    </label>
                  <div style={{ display: 'flex', gap: 10 }}>
                    <select
                      name="duration"
                      style={{ borderRadius: '4px', border: '1px solid lightgray', width: '40%', marginLeft: '-3px' }}
                      className="form-control w-100"
                      value={orderDetail.duration}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="" disabled selected>Select an option</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                    <select
                      style={{ borderRadius: '4px', border: '1px solid lightgray', width: '40%', marginLeft: '-3px' }}
                      className="form-control w-100"
                      name='durationUnit'
                      value={orderDetail.durationUnit}
                      required
                      onChange={handleInputChange}
                    >
                      <option value="Month">Month</option>
                      <option value="Year">Year</option>
                    </select>
                  </div>
                  </div>
                  <div className='' style={{ width: '80vw', marginTop: 10 }}>
                  </div>
              </div>
              <div className="row gx-3 mb-3">
                <div className="col-md-4">
                  <label className="small mb-1" htmlFor="inputCertificationId">
                    Work Type<span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                  </label>
                  <select
                    className='form-control'
                    name='workType'
                    value={orderDetail.workType}
                    onChange={handleInputChange}
                    required
                  >
                    <option value=''>SELECT</option>
                    <option value="REMOTE"> REMOTE</option>
                    <option value="ONSITE"> ONSITE </option>
                    <option value="HYBRID"> HYBRID </option>
                  </select>
                </div>
                <div className="col-md-2">
                  <label className="small mb-1" htmlFor="inputJobLocations">
                    Country
                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                  </label>
                  <select
                    className="form-select"
                    id="country"
                    name="country"
                    value={orderDetail?.country}
                    onChange={handleInputChange}
                    required
                    disabled={orderDetail.workType === 'REMOTE'}
                  >
                    <option value="" >select country</option>
                    {countriesData?.data?.map((option) => (
                      <option key={option?.country} value={option?.country}>  {option?.country}</option>))}
                    </select>
                </div>
                <div className="col-md-2">
                  <label className="small mb-1" htmlFor="inputJobLocations">
                    State
                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                  </label>
                  <select
                    className="form-select"
                    id="state"
                    name="state"
                    value={orderDetail?.state}
                    onChange={handleInputChange}
                    required
                    disabled={orderDetail.workType === 'REMOTE'}
                  >
                    <option value="" >select state</option>
                    {stateList && stateList?.data?.states?.map((option) => (
                      <option key={option?.name} value={option?.name}> {option?.name} </option>))}

                  </select>
                  </div>
                <div className="col-md-4">
                    <label className="small mb-1" htmlFor="inputCourseName">
                      Working Hour(per day)<span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                    </label>
                    <input
                      type="number"
                      min={1}
                      max={23}
                      id="inputCourseName"
                      className="form-control"
                      placeholder='Working Hour'
                      name="workingHours"
                      value={orderDetail.workingHours}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div className="row gx-3 mb-3">
                  <div className="col-md-4">
                  <label className="small mb-1" htmlFor="inputCertificationUrl">
                    Minimum Billing Hour(per day)
                  </label>
                  <input
                    type="number"
                    min={1}
                    max={23}
                    id="inputCertificationUrl"
                    className="form-control"
                    placeholder='billing hour'
                    name="minimumBillingHours"
                    value={orderDetail.minimumBillingHours}
                    onChange={handleInputChange}
                  />
                  </div>
                <div className="col-md-4">
                  <label className="small mb-1" htmlFor="inputCourseProvider">
                    Billing Interval<span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                  </label>
                  <select
                    id="inputCourseProvider"
                    className="form-control"
                    name="billingInterval"
                    placeholder='Billing Interval'
                    value={orderDetail.billingInterval}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">select</option>
                    <option value="Monthly">Monthly</option>
                    <option value="Weekly">Weekly</option>
                    <option value="Hourly">Hourly</option>
                  </select>
                  </div>
                  <div className="col-md-4 position-relative">
                  <label className="small mb-1" htmlFor="inputCourseProvider1">
                    Billing  Amount<span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                  </label>
                  <input
                    type="number"
                      min={1}
                    id="inputCourseProvider1"
                    className="form-control"
                    name="totalAmount"
                    placeholder='Billing Amount'
                    value={orderDetail.totalAmount}
                    onChange={handleInputChange}
                    required
                  />
                    <span style={{ color: 'green', top: '35px', right: '13px', position: 'absolute', borderLeft: '1px solid black', paddingLeft: '5px' }}>$ {orderDetail.totalAmount ? parseFloat(convertedPrice).toFixed(2) : '0.00'}</span>
                </div>
                </div>
                <div className="row gx-3 mb-3">
                  <div className="col-md-4">
                  <label className="small mb-1" htmlFor="inputCourseProvider2">
                    Currency<span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                  </label>
                  <select
                    className='form-control'
                    name='currency'
                    value={orderDetail?.currency}
                    onChange={handleInputChange}
                    required
                  >
                      {currency_data && currency_data.length > 0 ? (
                        currency_data.map((item, index) => (
                          <option key={item.index} value={item.code} style={{ color: 'black', backgroundColor: 'white' }}>
                            {item.code}
                          </option>
                        ))
                      ) : (
                        <option>Loading currencies...</option>
                      )}

                  </select>
                  </div>
                <div className="col-md-4">
                  <label className="small mb-1" htmlFor="inputFile">
                      Purchase Order (PDF)<span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                  </label>
                  <input
                    type="file"
                    id="inputFile"
                    className="form-control"
                      accept=".pdf, .doc, .docx"
                    onChange={handleFileChange}
                    required
                      disabled={orderDetail?.purchaseOrderId && orderDetail?.purchaseOrderUrl}
                  />
                  {error && <div className="text-danger">{error}</div>}
                    {orderDetail?.purchaseOrderId && orderDetail?.purchaseOrderUrl && (
                      <span
                        style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6, color: '#007bff' }}
                        onClick={() => window.open(orderDetail.purchaseOrderUrl, '_blank')}
                        title="View Purchase Order File"
                      >
                        <FiEye size={18} />
                        <span>View File</span>
                      </span>
                    )}
                  {fileInfo && (
                    <div className="mt-2">
                      {fileInfo.type === 'image' ? (
                        <div>
                          <img src={fileInfo.preview} alt={fileInfo.name} className="img-thumbnail" />
                          <div className="my-3">
                            <button type="button" className="btn btn-sm btn-danger" onClick={removeImage}>
                              Remove
                            </button>
                          </div>
                        </div>
                      ) : fileInfo.type === 'pdf' ? (
                        <div>
                          <p>Uploaded PDF: {fileInfo.name}</p>
                          <div className="my-3">
                            <button type="button" className="btn btn-sm btn-danger" onClick={removeImage}>
                              Remove
                            </button>
                          </div>
                        </div>
                      ) : fileInfo.type === 'doc' || fileInfo.type === 'docx' ? (
                        <div>
                          <p>Uploaded DOC: {fileInfo.name}</p>
                          <div className="my-3">
                            <button type="button" className="btn btn-sm btn-danger" onClick={removeImage}>
                              Remove
                            </button>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  )}
                  </div>
                </div>
                <button type="submit" className="btn-primary-custom px-5" disabled={buttonStatus || convertedLoader}>
                  {orderDetail?.purchaseOrderId && orderDetail?.purchaseOrderUrl
                    ? (buttonStatus ? 'Updating' : 'Update')
                    : (buttonStatus ? 'Adding' : 'Add')}
                </button>
            </form>
            </div>
        </div>
      }
    </div>

  )
}

export default ViewOrderPage;